"use client";

import SubscriptionCompetitionsProvider from "./provider";
import { SubscriptionCompetitionsPageContent } from "./page-content";
import DeviceProvider from "../../redux/features/device/DeviceProvider";
import "./subscription-competitions.css";

const SubscriptionCompetitionsPage = () => {
  return (
    <DeviceProvider>
      <SubscriptionCompetitionsProvider>
        <SubscriptionCompetitionsPageContent />
      </SubscriptionCompetitionsProvider>
    </DeviceProvider>
  );
};

export default SubscriptionCompetitionsPage;
